var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-development-tools"},[(_vm.computeToolName === 'api-test')?_c('ApiTestTool'):(_vm.computeToolName === 'sign')?_c('Sign'):(_vm.computeToolName === 'token-search')?_c('TokenSearch'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }